import { getCommentsForContentTypeAndContentId } from '@/api/wb/commentThread'
import { MinCommentThreadPayload } from 'common/src/api/websiteFrontendVsWebsiteBackend/commentThread/requests'
import { GetCommentsResponse } from 'common/src/api/websiteFrontendVsWebsiteBackend/commentThread/responses'
import { logger } from '@/logging/FrontendLogger'

export const fetchComments = async (
    payload: MinCommentThreadPayload
): Promise<GetCommentsResponse | null> => {
    const response = await getCommentsForContentTypeAndContentId(payload)
    if (!response.data.success) {
        logger.warn(
            `Failed to fetch comments: ${response.data.error} for payload: ${JSON.stringify(payload)}`
        )
        return []
    }
    if (response.data.payload === null) {
        logger.info(
            `Received null for content comment payload: ${JSON.stringify(
                payload
            )} - this means the content does not yet exist in WB.`
        )
        return null
    }
    return response.data.payload.sort(
        (commentA, commentB) =>
            new Date(commentA.createdAt).getTime() -
            new Date(commentB.createdAt).getTime()
    )
}
